import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../api";
import { useLang } from "../i18n";
import { StatsGrid } from "../components/SignalCard";
import { TradesTable, EquityChart } from "../components/TradesTable";

export default function Embed() {
  const [params] = useSearchParams();
  const { setLang, t } = useLang();
  const section = params.get("section") || "all";
  const [stats, setStats] = useState(null);
  const [equity, setEquity] = useState([]);
  const [trades, setTrades] = useState([]);

  useEffect(() => {
    const lang = params.get("lang");
    if (lang === "en" || lang === "it") setLang(lang);
  }, [params, setLang]);

  useEffect(() => {
    if (section !== "trades") {
      api.get("/public/performance").then((r) => setStats(r.data)).catch(() => {});
      api.get("/public/equity").then((r) => setEquity(r.data)).catch(() => {});
    }
    if (section !== "performance") {
      api.get("/public/trades").then((r) => setTrades(r.data.trades)).catch(() => {});
    }
  }, [section]);

  return (
    <div data-testid="embed-page" className="min-h-screen bg-[#050505] p-4 space-y-4">
      {section !== "trades" && (
        <>
          <StatsGrid stats={stats} />
          <EquityChart data={equity} />
        </>
      )}
      {section !== "performance" && (
        <TradesTable trades={trades} title={t("public_trades_title")} />
      )}
      <p className="text-[10px] text-slate-600 leading-relaxed">{t("disclaimer")}</p>
    </div>
  );
}
